import apiService from './api';
import type { ApiResponse } from '../types';

/**
 * A module's current terms of use and where this user stands with them.
 * Spray is not in this list — it has its own (services/sprayTnc.ts).
 */
export interface ModuleTerms {
  /** Version row id; what `accept` sends back. */
  id: number;
  module_key: string;
  /** The licence tier this version is written for, or 'all'. */
  audience: string;
  version: string;
  title: string;
  /** Markdown, shown pre-wrapped. */
  content: string;
  effective_from: string;
  /** Org subscribes (timesheet) or the user holds a seat (everything else). */
  hasAccess: boolean;
  hasAccepted: boolean;
}

export function getModuleTerms(): Promise<ApiResponse<ModuleTerms[]>> {
  return apiService.get<ModuleTerms[]>('/module-terms');
}

export function acceptModuleTerms(moduleKey: string, versionId: number): Promise<ApiResponse<unknown>> {
  return apiService.post(`/module-terms/${moduleKey}/accept`, { version_id: versionId });
}

/**
 * Which module a page belongs to, by path. The gate asks for a module's terms
 * only on that module's pages. Spray is absent on purpose (SprayTncGate).
 */
const MODULE_PATHS: [string, string[]][] = [
  ['timesheet', ['/timesheet', '/hr', '/payroll', '/approvals', '/whs', '/work', '/admin/work-schedule', '/admin/public-holidays']],
  ['irrigation', ['/irrigation', '/soil-sensors']],
  ['farm_jobs', ['/jobs', '/harvest']],
  ['vehicles', ['/equipment']],
  ['cultivar', ['/cultivar']],
  ['nursery', ['/nursery']],
  ['accounts', ['/accounts']],
  ['retail', ['/retail']],
  ['sales', ['/sales']],
  ['breeder', ['/breeder']],
  ['weather_stations', ['/weather-stations', '/weather/chill']],
];

export function moduleForPath(pathname: string): string | null {
  for (const [moduleKey, prefixes] of MODULE_PATHS) {
    if (prefixes.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return moduleKey;
  }
  return null;
}
